<template>
  <div v-loading="loading">
    <div class="w-full flex justify-between">
      <span class="text-xl">Audit Log - List</span>
      <div class="flex">
        <div
          class="w-8 h-8 flex rounded-full border items-center justify-center ml-2 cursor-pointer hover:bg-gray-200 select-none"
          @click="reload()"
        >
          <i class="el-icon-refresh"></i>
        </div>
      </div>
    </div>
    <hr class="my-2" />
    <!-- <vue-good-table
      :columns="columns"
      :rows="rows"
      :line-numbers="true"
      compactMode
      :sort-options="{
        enabled: true,
        initialSortBy: [{ field: 'LoggedTime', type: 'asc' }]
      }"
      styleClass="vgt-table bordered striped condensed"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 10
      }"
    >
      <template slot="table-row" slot-scope="props">
        <span :id="`${props.column.field}-${props.index}`" class="text-xs">
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table> -->

    <vue-good-table
      mode="remote"
      compactMode
      :line-numbers="true"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      @on-per-page-change="onPerPageChange"
      :totalRows="totalRecords"
      :pagination-options="{
        enabled: true,
      }"
      :sort-options="{
        enabled: true,
        initialSortBy: [{ field: 'logged_time', type: 'asc' }]
      }"
      :rows="rows"
      :columns="columns"
      styleClass="vgt-table bordered striped condensed">
      <template slot="table-row" slot-scope="props">
        <span :id="`${props.column.field}-${props.index}`" class="text-xs">
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  username: 'my-component',
  data() {
    return {
      loading: false,
      isLoading: false,
      columns: [
        {
          label: 'Username',
          field: 'created_by',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Message',
          field: 'message',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Callsite',
          field: 'callsite',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Timestamp',
          field: 'logged_time',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'yyyy-MM-dd HH:mm:ss',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Status',
          field: 'error_type',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        }
      ],
      rows: [],
      totalRecords: 0,
      // serverParams: {
      //   columnFilters: {
      //   },
      //   sort: {
      //     // field: '', 
      //     // type: '',
      //   },
      //   page: 1, 
      //   perPage: 10
      // },
      isAdmin: this.$store.state.auth.isAdmin,
      serverParams: {
        orderby: null,
        order: null,
        page: 1,
        view: 10,
        search: [
          // {
          //   key: 'callsite',
          //   value: 'Helper'
          // }
        ]
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.fetchData();
    },

    onPerPageChange(params) {
      this.updateParams({view: params.currentPerPage});
      this.fetchData();
    },

    onSortChange(params) {
      this.updateParams({
        orderby: params[0].field,
        order: params[0].type
      });
      this.fetchData();
    },
    
    onColumnFilter(params) {
      console.info('inimang filter', params.columnFilters)

      let searches = []

      for (const prop in params.columnFilters) {
        // console.info('inimang key', prop)
        // console.info('inimang value', params.columnFilters[prop])
        searches.push({
          key: prop,
          value: params.columnFilters[prop]
        })
      }
      

      this.updateParams({search: [...searches]});
      this.fetchData();
    },

    // loadItems() {
    //   getFromServer(this.serverParams).then(response => {
    //      this.totalRecords = response.totalRecords;
    //      this.rows = response.rows;
    //   });
    // },

    clearFilter(field) {
      try {
        let found = this.columns.find((c) => {
          return c.field == field
        })
        found.filterOptions.filterValue = ''
      } catch {
        alert(`Unable to clear ${field} filter`)
      }
    },
    changeFilter(field, newFilter) {
      let found = this.columns.find((c) => {
        return c.field == field
      })
      if (found) {
        if (found.hasOwnProperty('filterOptions')) {
          if (found.filterOptions.hasOwnProperty('filterValue')) {
            found.filterOptions.filterValue = newFilter
          } else {
            alert(`Column '${field}' does not have filterValue property!`)
          }
        } else {
          alert(`Column '${field}' does not have filtering configured!`)
        }
      } else {
        alert(`Field '${field}' does not exist!`)
      }
    },
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    },
    async fetchData() {
      try {
        this.showLoading()
        const { data } = await this.$axios.post('AuditLog/GetFilter', this.serverParams)

        this.totalRecords = data.total_data


        this.rows = data.data.map((item) => {
          item.logged_time = moment(item.logged_time).format(
            'YYYY-MM-DD hh:mm:ss'
          )
          return item
        })

        this.hideLoading()
      } catch (e) {
        this.hideLoading()
        console.log(e)
      }
    },
    reload() {
      this.fetchData()
    }
  }
}
</script>
